export default class BasketSource {
  static get Web () { return 'web' } // веб
  static get Crm () { return 'crm' } // црм
  static get DeliveryClub () { return 'deliveryСlub' } // деливери клаб
  static get Yandex () { return 'yandex' } // яндекекс еда

  static get SberMarket () { return 'sber_market' }
  static get Chibis () { return 'chibis' }

  static getAggregatorsSources () {
    return [
      BasketSource.Yandex,
      BasketSource.DeliveryClub,
      BasketSource.SberMarket,
      BasketSource.Chibis,
    ]
  }
}
